import apiService from './api-service';

const Invoices = {};
const urlEntity = "/mail/recover-password";

Invoices.recover = (data) => {
    return apiService.post(urlEntity, data)
        .then((res) => res);
};

export default Invoices;
